// Single source of truth for Fresh & Homely store details.
// Values are the ones already published on the site — do not change them here
// without confirming against the live store information.
export const STORE = {
  name: 'Fresh & Homely',
  phone: '+91 90194 07023',
  phoneHref: 'tel:+919019407023',
  address:
    'Shop No. 1 and 2, No.12, Bhartiya City Back Gate Rd, Devin Paradise Enclave, Nagareshwara - Nagenahalli, Bengaluru, Karnataka 560077',
  mapsUrl:
    'https://www.google.com/maps/search/?api=1&query=Fresh+%26+Homely+Shop+No.+1+and+2+Bhartiya+City+Back+Gate+Rd+Devin+Paradise+Enclave+Bengaluru',
};

// Canonical metadata must identify the public site rather than whichever
// preview, S3, or container origin happens to serve the current build.
export const SITE_ORIGIN = (
  process.env.REACT_APP_SITE_ORIGIN || 'https://freshandhomely.com'
).replace(/\/+$/, '');

// Product ranges the store actually sells, mirroring the homepage Categories
// section. Kept here so the Support page can answer "what do you offer?"
// without restating the list in prose that can drift out of sync.
export const PRODUCT_RANGES = [
  'Freshwater Fish',
  'Sea Fish',
  'Dairy Products',
  'Meat',
  'Grocery Essentials',
];
